export enum TimeUnit {
	Seconds = "seconds",
	Minutes = "minutes",
	Hours = "hours",
	Days = "days",
}

const MS_PER_UNIT: Record<TimeUnit, number> = {
	[TimeUnit.Seconds]: 1000,
	[TimeUnit.Minutes]: 1000 * 60,
	[TimeUnit.Hours]: 1000 * 60 * 60,
	[TimeUnit.Days]: 1000 * 60 * 60 * 24,
};

export const duration = (amount: number, unit: TimeUnit): number =>
	amount * MS_PER_UNIT[unit];
